import { Route } from 'react-router';
import { Page } from '@roc/feature-app-core';
import { AppraiserDashboard } from '../components/appraiserDashboard';


export const getAppraiserInternalRoutesConfig = (
  basePath: string,
  baseUrl: string,
) => {
  return {
    appraisers: {
      path: `${basePath}/appraisers`,
      url: `${baseUrl}/appraisers`,
      documentTitle: 'Appraisers',
    }
  };
};

export const getAppraiserInternalRoutes = (
  basePath: string,
  baseUrl: string,
) => {
  const config = getAppraiserInternalRoutesConfig(basePath, baseUrl);

  return {
    appraisers: (
      <Route exact path={config.appraisers.path}>
        <Page routeDefinition={config.appraisers}>
          <AppraiserDashboard />
        </Page>
      </Route>
    )
  };
}
